export default __webpack_public_path__ + "static/media/w2.94fe7c3d.webp";